import { Button } from '@components/button';
import { useContactUsModal } from '@components/modal';
import { Typography } from '@components/typography';
import { navigate } from 'gatsby';
import posthog from 'posthog-js';
import { ExpiredModalWrapper } from './ExpiredModalWrapper';
import { ProgressCircle } from './ProgressCircle';

type ExpiredModalProps = {
  workspacesPage?: boolean;
  organizationId: string;
  name?: string;
};

export const ExpiredModal = ({ workspacesPage, organizationId, name }: ExpiredModalProps) => {
  const { showModal: openContactUsModal } = useContactUsModal({
    componentProps: {
      defaultSubject: `Plan information for ${name} (${organizationId})`,
    },
  });

  const handleContactUsButton = () => {
    posthog.capture('user_contact-us_intent', {
      location: 'organizations-plan-information',
    });
    openContactUsModal();
  };

  const handleGoToHomeButton = async () => {
    await navigate('/');
  };
  return (
    <ExpiredModalWrapper>
      <Typography variant="subtitle1">Your subscription has expired</Typography>
      <ProgressCircle content="Expired" value={100} error />
      <Typography variant="body2" textAlign="center">
        Please contact us to continue using our platform.
      </Typography>
      <Button fullWidth onClick={handleContactUsButton}>
        Contact us
      </Button>
      {workspacesPage && (
        <Button variant="secondary" fullWidth onClick={handleGoToHomeButton}>
          Go back to home page
        </Button>
      )}
    </ExpiredModalWrapper>
  );
};
